var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 346 712",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M330.504 48.8666C330.504 30.3212 315.483 15.3002 296.937 15.3002H267.147C263.439 15.3002 260.434 18.3058 260.434 22.0135V22.8527C260.434 33.0904 252.21 41.3142 241.972 41.3142H104.35C94.1119 41.3142 85.8881 33.0904 85.8881 22.8527V22.0135C85.8881 18.3058 82.8825 15.3002 79.1749 15.3002H49.3846C30.8392 15.3002 15.8182 30.3212 15.8182 48.8666V663.132C15.8182 681.678 30.8392 696.699 49.3846 696.699H296.937C315.483 696.699 330.504 681.678 330.504 663.132V48.8666ZM49.3846 0.195312H296.937C323.79 0.195312 345.608 22.0135 345.608 48.8666V663.132C345.608 689.986 323.79 711.804 296.937 711.804H49.3846C22.5315 711.804 0.713318 689.986 0.713318 663.132V48.8666C0.713318 22.0135 22.5315 0.195312 49.3846 0.195312Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M117.357 685.789C117.357 684.631 118.296 683.691 119.455 683.691H227.706C228.865 683.691 229.804 684.631 229.804 685.789C229.804 686.948 228.865 687.887 227.706 687.887H119.455C118.296 687.887 117.357 686.948 117.357 685.789Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.797 22.8526C216.797 26.0968 214.167 28.7268 210.923 28.7268C207.679 28.7268 205.049 26.0968 205.049 22.8526C205.049 19.6085 207.679 16.9785 210.923 16.9785C214.167 16.9785 216.797 19.6085 216.797 22.8526Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.28 20.3352C152.889 20.3352 151.762 21.4623 151.762 22.8526C151.762 24.243 152.889 25.3701 154.28 25.3701H191.203C192.593 25.3701 193.72 24.243 193.72 22.8526C193.72 21.4623 192.593 20.3352 191.203 20.3352H154.28Z",
    fill: "#4F4F4F"
  })));
};

export default __webpack_public_path__ + "static/media/MobileFrame.0037e248.svg";
export { SvgComponent as ReactComponent };